export const ApiList = {
  LOGIN: "auth/admin-login",
  FORGOT_PASSWORD: "auth/forgot-password",
  GET_ALL_CLUBS:"/club/get-all",
  GET_CLUB_DETAILS:"/club/get-club",
  GET_CLUB_USERS:"/user/get-all",
  ADD_CLUB:"/club/add-club",
  ADD_USER:"/user/add-user",
  ADD_USER_TO_CLUB:"/club/add-user-to-club",
  getImageUrl:"/auth/get-presigned-url",
  GET_AWS_REGIONS:"/base/get",
  GET_INSTANCE_TYPES:"/club/get-instance-types",
};
